export default "__VITE_ASSET__BipIsGNY__"